import { AddCategoryForm as SharedAddCategoryForm, type AddCategoryFormProps } from '@dataroom/shared';
import { useAddCategoryAndFile } from '@/api/add-category';

interface AdminAddCategoryFormProps extends Omit<AddCategoryFormProps, 'add'> {
  roomId: string;
}

/**
 * "Add a new category…" in the review panel (owner ask 2026-10-12): the shared
 * form (shared/src/ui/add-category-form.tsx — the seller portal files with it
 * too) wired to the admin's create-and-file mutation. Mounted only while open.
 */
export function AddCategoryForm({ roomId, ...props }: AdminAddCategoryFormProps) {
  const add = useAddCategoryAndFile(roomId);
  return <SharedAddCategoryForm {...props} add={add} />;
}
